export default {
  data () {
    return {
      isCaptchaRendered: false
    }
  },

  computed: {
    recaptchaKey () {
      return (this.$config && this.$config.recaptchaKey) || ''
    },

    recaptchaEnterprise () {
      const value = !!(this.$config && this.$config.recaptchaEnterprise)
      console.log('[reCAPTCHA] recaptchaEnterprise computed:', value)
      return value
    },

    recaptchaApi () {
      if (!window.grecaptcha) {
        return null
      }
      return this.recaptchaEnterprise ? window.grecaptcha.enterprise : window.grecaptcha
    }
  },

  methods: {
    loadRecaptchaScript (onloadCallback = 'renderCaptcha') {
      if (this.recaptchaKey.length === 0) {
        return
      }

      if (typeof window.grecaptcha !== 'undefined') {
        return
      }

      const recaptchaScript = document.createElement('script')
      const scriptBase = this.recaptchaEnterprise
        ? 'https://www.google.com/recaptcha/enterprise.js'
        : 'https://www.google.com/recaptcha/api.js'

      const locale = this.$i18n && this.$i18n.locale
        ? this.$i18n.locale.split('-')[0]
        : 'en'

      recaptchaScript.setAttribute('src', `${scriptBase}?onload=${onloadCallback}&render=explicit&hl=${locale}`)
      recaptchaScript.setAttribute('defer', 'true')
      recaptchaScript.setAttribute('async', 'true')
      document.head.appendChild(recaptchaScript)
    },

    renderRecaptcha (containerId = 'recaptcha', options = {}) {
      if (this.isCaptchaRendered || this.recaptchaKey.length === 0) {
        return
      }

      this.recaptchaApi.render(containerId, {
        sitekey: this.recaptchaKey,
        ...options
      })
      this.isCaptchaRendered = true
    },

    getRecaptchaResponse () {
      return this.recaptchaApi.getResponse()
    },

    resetRecaptcha () {
      this.recaptchaApi.reset()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/recaptcha.js